import { createStyles } from '@mantine/core';

export const useGLMCardStyles = createStyles(theme => ({
  card: {
    border: `1px solid ${theme.colors.gray[3]}`,
    borderRadius: theme.radius.md,
    padding: '10px 14px',
    backgroundColor: theme.white,
    '&:hover': {
      backgroundColor: '#F2FBFF',
    },
  },
  cardSelected: {
    border: '2px solid #16B8FF',
    backgroundColor: '#E7F5FF',
    '&:hover': {
      backgroundColor: '#E7F5FF',
    },
  },
  cardDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
  groupLabel: {
    textTransform: 'uppercase' as const,
    letterSpacing: '0.05em',
  },
}));
